import { useIntl } from 'react-intl';
import { Stack, Typography } from '@rossum/ui/material';
import { GridRenderCellParams, GridRowModel } from '@rossum/ui/x-data-grid-pro';
import { TransformedAnnotation } from '../hooks/useTransformAnnotation';

type SimpleQueueCellValue = TransformedAnnotation['queueName'];

export const SimpleQueue = ({
  value,
}: GridRenderCellParams<GridRowModel, SimpleQueueCellValue>) => {
  const intl = useIntl();

  const queueName =
    value ?? intl.formatMessage({ id: 'components.duplicates.unknownQueue' });

  return (
    <Stack width="100%" height="100%" justifyContent="center">
      <Typography
        sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
        variant="body2"
      >
        {queueName}
      </Typography>
    </Stack>
  );
};
